import navLogo from "../../../Assets/Images/logo.svg";
import {
    Grid2, Typography, Box, Table, TableBody, TableRow, TableCell,
    Switch, FormControlLabel, FormGroup, Button, Checkbox, Radio
} from "@mui/material";

import { styled } from "@mui/material";
import SignUpBg from "../../../Assets/Images/Signup_web.png";
import DisStyles from "./dis.module.css";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { disProceed, setDisStatus } from "../../../Redux/usersSlice";
import collab from '../../../Assets/Images/collab1.svg';

export default function DIS() {

    const { loading, userData,source } = useSelector((state) => state.user);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: 42,
        height: 26,
        padding: 0,
        "& .MuiSwitch-switchBase": {
            padding: 0,
            margin: 2,
            transitionDuration: "300ms",
            "&.Mui-checked": {
                transform: "translateX(16px)",
                color: "#fff",
                "& + .MuiSwitch-track": {
                    backgroundColor: "#FFBF00  ",
                    opacity: 1,
                    border: 0
                }
            }
        },
        "& .MuiSwitch-thumb": { boxSizing: "border-box", width: 22, height: 22 },
        "& .MuiSwitch-track": { borderRadius: 26 / 2, backgroundColor: "#E9E9EA", opacity: 1 }
    }));

    // 1) Defaults that match the image
    const defaultSwitches = {
        switch1: true, // smsAlerts = yes
        switch2: true, // standingInstruction = yes
        switch3: false, // autoPledge = no
        switch4: false, // disBooklet = no
        switch5: false, // powerOfAttorney = no
        switch6: true // onlineAccess = yes
    };

    const defaultRadios = {
        securities: "Yes", // ddpiTransfer
        pledge: "Yes", // ddpiPledge
        accStatement: "Yes", // ddpiOpenOffers
        rights: "Email", // rightsObligationsMode
        reports: "Email", // issuerCommunication
        accStm: "Email" // accountStatementMode
    };

    const [switches, setSwitches] = useState(defaultSwitches);
    const [radioValues, setRadioValues] = useState(defaultRadios);

    const handleSwitchChange = (name) => (event) => {
        setSwitches((prev) => ({ ...prev, [name]: event.target.checked }));
    };

    const handleRadioChange = (key, value) => {
        setRadioValues((prev) => ({ ...prev, [key]: value }));
    };

    const controlProps = (rowKey, item) => ({
        checked: radioValues[rowKey] === item,
        onChange: () => handleRadioChange(rowKey, item),
        value: item,
        name: rowKey,
        inputProps: { "aria-label": item },
        sx: {
            color: "#ccc",
            "&.Mui-checked": { color: "#FFBF00  " }
        }
    });

    // Helpers for payload
    const toYesNo = (b) => (b ? "yes" : "no");
    const lower = (s) => s.toLowerCase();

    // Baseline payload from defaults
    const baselinePayload = {
        smsAlerts: toYesNo(defaultSwitches.switch1),
        standingInstruction: toYesNo(defaultSwitches.switch2),
        autoPledge: toYesNo(defaultSwitches.switch3),
        disBooklet: toYesNo(defaultSwitches.switch4),
        powerOfAttorney: toYesNo(defaultSwitches.switch5),
        onlineAccess: toYesNo(defaultSwitches.switch6),
        ddpiTransfer: lower(defaultRadios.securities), // "yes"/"no"
        ddpiPledge: lower(defaultRadios.pledge),
        ddpiOpenOffers: lower(defaultRadios.accStatement),
        rightsObligationsMode: lower(defaultRadios.rights), // "physical"/"email"
        issuerCommunication: lower(defaultRadios.reports),
        accountStatementMode: lower(defaultRadios.accStm)
    };

    // Current payload from state
    const currentPayload = {
        smsAlerts: toYesNo(switches.switch1),
        standingInstruction: toYesNo(switches.switch2),
        autoPledge: toYesNo(switches.switch3),
        disBooklet: toYesNo(switches.switch4),
        powerOfAttorney: toYesNo(switches.switch5),
        onlineAccess: toYesNo(switches.switch6),
        ddpiTransfer: lower(radioValues.securities),
        ddpiPledge: lower(radioValues.pledge),
        ddpiOpenOffers: lower(radioValues.accStatement),
        rightsObligationsMode: lower(radioValues.rights),
        issuerCommunication: lower(radioValues.reports),
        accountStatementMode: lower(radioValues.accStm)
    };

    // Build a diff so only changed fields are sent
    const buildChangedOnly = () =>
        Object.fromEntries(
            Object.entries(currentPayload).filter(([k, v]) => v !== baselinePayload[k])
        );

      useEffect(()=>{
          const isDISNotPresent = !("DIS Slip" in (userData?.steps || {}))
    
           const isDISDone=userData?.steps?.["DIS Slip"]?.status
    
           console.log("DIS Slip NotPresent",isDISNotPresent,"DIS Slip Done",isDISDone)
        //    console.log(isEsignDone)
          if(isDISDone || isDISNotPresent){
              navigate('/e_sign')
          } else {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                  event: "kyc_step_viewed",
                  step_name: "dis_page_viewed",
                  page_path: window.location.pathname
              });
          }
       },[])

    const HandleDisClick = async () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "kyc_step_viewed",
            step_name: "dis_captured",
            page_path: window.location.pathname
        });
        try {
            const changedOnly = buildChangedOnly();
            console.log(changedOnly)

            let response

            if (Object.keys(changedOnly).length === 0) {
                console.log("Object is empty");
                response = await dispatch(
                    disProceed({
                        email: userData.email.toLowerCase(),
                        mobile: userData.mobile,
                        dis_change: false,
                        dis_slip: null
                    })
                ).unwrap();
            } else {
                console.log("Object is not empty");

                console.log("changedOnly",changedOnly)

                console.log("dis payload", {
                    email: userData.email.toLowerCase(),
                    mobile: userData.mobile,
                    dis_change: true,
                    dis_slip: changedOnly,
                    poa: currentPayload.powerOfAttorney === "yes" ? true : false
                })
                
                response = await dispatch(
                    disProceed({
                        email: userData.email.toLowerCase(),
                        mobile: userData.mobile,
                        dis_change: true,
                        dis_slip: changedOnly,
                        poa: currentPayload.powerOfAttorney === "yes" ? true : false
                    })
                ).unwrap();
              
            

            }
            if (response.data?.data?.success) {
                navigate("/e_sign");
                dispatch(setDisStatus());
            }
        } catch (error) {
            console.error("Error in dis submit api", error);
        }
    };

    return (
        <main>
            <Box
                className={DisStyles.outerCard}
                sx={{
                    minHeight: "100vh",
                    backgroundImage: `url(${SignUpBg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center"
                }}
            >
                <Box className={DisStyles.content_wrapper}>
                    <Grid2 sx={{ display: "flex", justifyContent: "center",flexDirection:"column",alignItems:"center" }}>
                        <img src={source == "cosmos" ? collab : navLogo} alt="Logo" className={source == "cosmos" ? DisStyles.twologo : DisStyles.nav_logo} />
                        {
                            source == "cosmos" &&
                            <Typography className={DisStyles.txt1}>
                                Together with Tradeboss, CFG India simplifies Investing in Listed/ Unlisted securities.
                            </Typography>
                        }
                    </Grid2>

                    {/* text */}
                    <Typography className={DisStyles.heading}>
                        Demat Account Instructions
                    </Typography>

                    <Table>
                        <TableBody>

                            <TableRow>
                                {window.innerWidth > 480 && (
                                    <TableCell className={DisStyles.tableCell} style={{ borderColor: "#404B59" }}>
                                        <Typography className={DisStyles.table_text}>
                                            I/We would like to get SMS Alerts
                                        </Typography>
                                    </TableCell>
                                )}
                                <TableCell className={DisStyles.tableCell1} style={{ borderColor: "#404B59" }}>
                                    {window.innerWidth <= 480 && (
                                        <Typography className={DisStyles.table_text}>
                                            I/We would like to get SMS Alerts
                                        </Typography>
                                    )}
                                    <FormGroup row>
                                        <FormControlLabel
                                            control={
                                                <IOSSwitch
                                                    checked={switches.switch1}
                                                    onChange={handleSwitchChange("switch1")}
                                                />
                                            }
                                            label="Yes"
                                            sx={{
                                                color: "#000",
                                                marginLeft: "0px",
                                                "& .MuiFormControlLabel-label": {
                                                    marginLeft: "6px",
                                                    fontFamily: "Inter400",
                                                    fontSize: "16px",
                                                    "@media (max-width: 1090px)": { fontSize: "14px" }
                                                }
                                            }}
                                        />
                                    </FormGroup>
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                {window.innerWidth > 480 && (
                                    <TableCell className={DisStyles.tableCell} style={{ borderColor: "#404B59" }}>
                                        <Typography className={DisStyles.table_text}>
                                            I would like place a Standing Instruction to receive credit automatically into my account
                                        </Typography>
                                    </TableCell>
                                )}
                                <TableCell className={DisStyles.tableCell1} style={{ borderColor: "#404B59" }}>
                                    {window.innerWidth <= 480 && (
                                        <Typography className={DisStyles.table_text}>
                                            I would like place a Standing Instruction to receive credit automatically into my account
                                        </Typography>
                                    )}
                                    <FormGroup row>
                                        <FormControlLabel
                                            control={
                                                <IOSSwitch
                                                    checked={switches.switch2}
                                                    onChange={handleSwitchChange("switch2")}
                                                />
                                            }
                                            label="Yes"
                                            sx={{
                                                color: "#000",
                                                marginLeft: "0px",
                                                "& .MuiFormControlLabel-label": {
                                                    marginLeft: "6px",
                                                    fontFamily: "Inter400",
                                                    fontSize: "16px",
                                                    "@media (max-width: 1090px)": { fontSize: "14px" }
                                                }
                                            }}
                                        />
                                    </FormGroup>
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                {window.innerWidth > 480 && (
                                    <TableCell className={DisStyles.tableCell} style={{ borderColor: "#404B59" }}>
                                        <Typography className={DisStyles.table_text}>
                                            I would like to place an Auto Pledge Confirmation
                                        </Typography>
                                    </TableCell>
                                )}
                                <TableCell className={DisStyles.tableCell1} style={{ borderColor: "#404B59" }}>
                                    {window.innerWidth <= 480 && (
                                        <Typography className={DisStyles.table_text}>
                                            I would like to place an Auto Pledge Confirmation
                                        </Typography>
                                    )}
                                    <FormGroup row>
                                        <FormControlLabel
                                            control={
                                                <IOSSwitch
                                                    checked={switches.switch3}
                                                    onChange={handleSwitchChange("switch3")}
                                                />
                                            }
                                            label="Yes"
                                            sx={{
                                                color: "#000",
                                                marginLeft: "0px",
                                                "& .MuiFormControlLabel-label": {
                                                    marginLeft: "6px",
                                                    fontFamily: "Inter400",
                                                    fontSize: "16px",
                                                    "@media (max-width: 1090px)": { fontSize: "14px" }
                                                }
                                            }}
                                        />
                                    </FormGroup>
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                {window.innerWidth > 480 && (
                                    <TableCell className={DisStyles.tableCell} style={{ borderColor: "#404B59" }}>
                                        <Typography className={DisStyles.table_text}>
                                            I would like to Receive DIS booklet at the time of account opening
                                        </Typography>
                                    </TableCell>
                                )}
                                <TableCell className={DisStyles.tableCell1} style={{ borderColor: "#404B59" }}>
                                    {window.innerWidth <= 480 && (
                                        <Typography className={DisStyles.table_text}>
                                            I would like to Receive DIS booklet at the time of account opening
                                        </Typography>
                                    )}
                                    <FormGroup row>
                                        <FormControlLabel
                                            control={
                                                <IOSSwitch
                                                    checked={switches.switch4}
                                                    onChange={handleSwitchChange("switch4")}
                                                />
                                            }
                                            label="Yes"
                                            sx={{
                                                color: "#000",
                                                marginLeft: "0px",
                                                "& .MuiFormControlLabel-label": {
                                                    marginLeft: "6px",
                                                    fontFamily: "Inter400",
                                                    fontSize: "16px",
                                                    "@media (max-width: 1090px)": { fontSize: "14px" }
                                                }
                                            }}
                                        />
                                    </FormGroup>
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                {window.innerWidth > 480 && (
                                    <TableCell className={DisStyles.tableCell} style={{ borderColor: "#404B59" }}>
                                        <Typography className={DisStyles.table_text}>
                                            I would like my account to be operated through Power of Attorney
                                        </Typography>
                                    </TableCell>
                                )}
                                <TableCell className={DisStyles.tableCell1} style={{ borderColor: "#404B59" }}>
                                    {window.innerWidth <= 480 && (
                                        <Typography className={DisStyles.table_text}>
                                            I would like my account to be operated through Power of Attorney
                                        </Typography>
                                    )}
                                    <FormGroup row>
                                        <FormControlLabel
                                            control={
                                                <IOSSwitch
                                                    checked={switches.switch5}
                                                    onChange={handleSwitchChange("switch5")}
                                                />
                                            }
                                            label="Yes"
                                            sx={{
                                                color: "#000",
                                                marginLeft: "0px",
                                                "& .MuiFormControlLabel-label": {
                                                    marginLeft: "6px",
                                                    fontFamily: "Inter400",
                                                    fontSize: "16px",
                                                    "@media (max-width: 1090px)": { fontSize: "14px" }
                                                }
                                            }}
                                        />
                                    </FormGroup>
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                {window.innerWidth > 480 && (
                                    <TableCell className={DisStyles.tableCell} style={{ borderColor: "#404B59" }}>
                                        <Typography className={DisStyles.table_text}>
                                            I would like to have Online access to demat account
                                        </Typography>
                                    </TableCell>
                                )}
                                <TableCell className={DisStyles.tableCell1} style={{ borderColor: "#404B59" }}>
                                    {window.innerWidth <= 480 && (
                                        <Typography className={DisStyles.table_text}>
                                            I would like to have Online access to demat account
                                        </Typography>
                                    )}
                                    <FormGroup row>
                                        <FormControlLabel
                                            control={
                                                <IOSSwitch
                                                    checked={switches.switch6}
                                                    onChange={handleSwitchChange("switch6")}
                                                />
                                            }
                                            label="Yes"
                                            sx={{
                                                color: "#000",
                                                marginLeft: "0px",
                                                "& .MuiFormControlLabel-label": {
                                                    marginLeft: "6px",
                                                    fontFamily: "Inter400",
                                                    fontSize: "16px",
                                                    "@media (max-width: 1090px)": { fontSize: "14px" }
                                                }
                                            }}
                                        />
                                    </FormGroup>
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                {window.innerWidth > 480 && (
                                    <TableCell className={DisStyles.tableCell} style={{ borderColor: "#404B59" }}>
                                        <Typography className={DisStyles.table_text}>
                                            DDPI for transfer of securities
                                        </Typography>
                                    </TableCell>
                                )}
                                <TableCell className={DisStyles.tableCell1} style={{ borderColor: "#404B59" }}>
                                    {window.innerWidth <= 480 && (
                                        <Typography className={DisStyles.table_text}>
                                            Mode of receiving account statement
                                        </Typography>
                                    )}
                                    <Box className={DisStyles.card}>
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            <Radio {...controlProps("securities", "Yes")} />
                                            <Typography variant="body2" className={DisStyles.label}>Yes</Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            <Radio {...controlProps("securities", "No")} />
                                            <Typography variant="body2" className={DisStyles.label}>No</Typography>
                                        </Box>
                                    </Box>
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                {window.innerWidth > 480 && (
                                    <TableCell className={DisStyles.tableCell} style={{ borderColor: "#404B59" }}>
                                        <Typography className={DisStyles.table_text}>
                                            DDPI for pledge/repledge
                                        </Typography>
                                    </TableCell>
                                )}
                                <TableCell className={DisStyles.tableCell1} style={{ borderColor: "#404B59" }}>
                                    {window.innerWidth <= 480 && (
                                        <Typography className={DisStyles.table_text}>
                                            DDPI for pledge/repledge
                                        </Typography>
                                    )}
                                    <Box className={DisStyles.card}>
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            <Radio {...controlProps("pledge", "Yes")} />
                                            <Typography variant="body2" className={DisStyles.label}>Yes</Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            <Radio {...controlProps("pledge", "No")} />
                                            <Typography variant="body2" className={DisStyles.label}>No</Typography>
                                        </Box>
                                    </Box>
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                {window.innerWidth > 480 && (
                                    <TableCell className={DisStyles.tableCell} style={{ borderColor: "#404B59" }}>
                                        <Typography className={DisStyles.table_text}>
                                            DDPI for open offers
                                        </Typography>
                                    </TableCell>
                                )}
                                <TableCell className={DisStyles.tableCell1} style={{ borderColor: "#404B59" }}>
                                    {window.innerWidth <= 480 && (
                                        <Typography className={DisStyles.table_text}>
                                            DDPI for open offers
                                        </Typography>
                                    )}
                                    <Box className={DisStyles.card}>
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            <Radio {...controlProps("accStatement", "Yes")} />
                                            <Typography variant="body2" className={DisStyles.label}>Yes</Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            <Radio {...controlProps("accStatement", "No")} />
                                            <Typography variant="body2" className={DisStyles.label}>No</Typography>
                                        </Box>
                                    </Box>
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                {window.innerWidth > 480 && (
                                    <TableCell className={DisStyles.tableCell} style={{ borderColor: "#404B59" }}>
                                        <Typography className={DisStyles.table_text}>
                                            Mode of receiving rights and obligations document
                                        </Typography>
                                    </TableCell>
                                )}
                                <TableCell className={DisStyles.tableCell1} style={{ borderColor: "#404B59" }}>
                                    {window.innerWidth <= 480 && (
                                        <Typography className={DisStyles.table_text}>
                                            Mode of receiving rights and obligations document
                                        </Typography>
                                    )}
                                    <Box className={DisStyles.card}>
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            <Radio {...controlProps("rights", "Physical")} />
                                            <Typography variant="body2" className={DisStyles.label}>Physical</Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            <Radio {...controlProps("rights", "Email")} />
                                            <Typography variant="body2" className={DisStyles.label}>Email</Typography>
                                        </Box>
                                    </Box>
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                {window.innerWidth > 480 && (
                                    <TableCell className={DisStyles.tableCell} style={{ borderColor: "#404B59" }}>
                                        <Typography className={DisStyles.table_text}>
                                            Mode of receiving annual reports, AGM notice and other communication from issuer
                                        </Typography>
                                    </TableCell>
                                )}
                                <TableCell className={DisStyles.tableCell1} style={{ borderColor: "#404B59" }}>
                                    {window.innerWidth <= 480 && (
                                        <Typography className={DisStyles.table_text}>
                                            Mode of receiving annual reports, AGM notice and other communication from issuer
                                        </Typography>
                                    )}
                                    <Box className={DisStyles.card}>
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            <Radio {...controlProps("reports", "Physical")} />
                                            <Typography variant="body2" className={DisStyles.label}>Physical</Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            <Radio {...controlProps("reports", "Email")} />
                                            <Typography variant="body2" className={DisStyles.label}>Email</Typography>
                                        </Box>
                                    </Box>
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                {window.innerWidth > 480 && (
                                    <TableCell className={DisStyles.tableCell} style={{ borderColor: "#404B59" }}>
                                        <Typography className={DisStyles.table_text}>
                                            Mode of receiving account statement
                                        </Typography>
                                    </TableCell>
                                )}
                                <TableCell className={DisStyles.tableCell1} style={{ borderColor: "#404B59" }}>
                                    {window.innerWidth <= 480 && (
                                        <Typography className={DisStyles.table_text}>
                                            Mode of receiving account statement
                                        </Typography>
                                    )}
                                    <Box className={DisStyles.card}>
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            <Radio {...controlProps("accStm", "Physical")} />
                                            <Typography variant="body2" className={DisStyles.label}>Physical</Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            <Radio {...controlProps("accStm", "Email")} />
                                            <Typography variant="body2" className={DisStyles.label}>Email</Typography>
                                        </Box>
                                    </Box>
                                </TableCell>
                            </TableRow>

                        </TableBody>
                    </Table>
                </Box>

                <Grid2
                    sx={{
                        position: "fixed",
                        bottom: 0,
                        left: 0,
                        width: "100%",
                        py: 2,
                        display: "flex",
                        justifyContent: "center",
                        background: "rgba(255,255,255,0.6)" // translucent so bg shows through
                    }}
                >
                    <Button className={DisStyles.joinDiplomtsBtn} onClick={HandleDisClick}>
                        Agree & Proceed
                    </Button>
                </Grid2>
            </Box>
        </main>

    )
}